"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopRatedProductRankingWidgetDataSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
var lib_unit_optimization_item_v1_dto_1 = require("./lib-unit-optimization-item-v1-dto");
/**
 * 위젯 아이템
 * @see {@link https://yanolja-dev-cx-api-bucket.s3.ap-northeast-2.amazonaws.com/api-document/cx-display-api/classes/controller_widget_top_rated_product_ranking_dto_widget_v1_top_rated_product_ranking_response_dto._internal_.WidgetTopRatedProductRankingResponseTabItemDto.html}
 * */
var WidgetTopRatedProductRankingResponseTabItemDto = lib_unit_optimization_item_v1_dto_1.LibUnitOptimizationItemV1Dto.extend({
    logMeta: common_1.CommonItemLogMetaDto,
});
/**
 * 더보기 탭 헤더
 * @see {@link  https://yanolja-dev-cx-api-bucket.s3.ap-northeast-2.amazonaws.com/api-document/cx-display-api/classes/controller_widget_top_rated_product_ranking_dto_widget_v1_top_rated_product_ranking_response_dto._internal_.WidgetTopRatedProductRankingResponseTabHeaderMoreDto.html}
 * */
var WidgetTopRatedProductRankingResponseTabHeaderMoreDto = zod_1.z.object({
    /** 더보기 링크 */
    action: common_1.CommonResponseItemActionDto.optional(),
    /** 더보기 타이틀 */
    title: zod_1.z.string(),
    /**
     * 더보기 로그 메타
     * @see {@link https://yanolja-dev-cx-api-bucket.s3.ap-northeast-2.amazonaws.com/api-document/cx-display-api/classes/controller_widget_top_rated_product_ranking_dto_widget_v1_top_rated_product_ranking_response_dto._internal_.WidgetTopRatedProductRankingResponseTabHeaderMoreLogMetaDto.html}
     * */
    logMeta: zod_1.z.record(zod_1.z.unknown()),
});
/**
 * 위젯 공통 헤더 모델
 * more을 재정의해서 사용할 것
 * @see {@link https://yanolja-dev-cx-api-bucket.s3.ap-northeast-2.amazonaws.com/api-document/cx-display-api/classes/controller_widget_top_rated_product_ranking_dto_widget_v1_top_rated_product_ranking_response_dto._internal_.WidgetTopRatedProductRankingResponseTabHeaderDto.html}
 * */
var WidgetTopRatedProductRankingResponseTabHeaderDto = zod_1.z.object({
    /** 위젯 타이틀 아이콘 추후 2개 이상의 아이콘이 필요시 titleIcon으로 변경하고 prefix, postfix로 구분하여 return할 것 */
    icon: zod_1.z.string().optional(),
    /** 더보기 */
    more: WidgetTopRatedProductRankingResponseTabHeaderMoreDto.optional(),
    /** 위젯 타이틀 */
    title: zod_1.z.string(),
    /** 위젯 서브 타이틀 */
    subTitle: zod_1.z.string().optional(),
});
/**
 * 실험 메타 데이터
 * @see {@link https://yanolja-dev-cx-api-bucket.s3.ap-northeast-2.amazonaws.com/api-document/cx-display-api/classes/controller_widget_v2_dto_recommendation_chipless_ranking_widget_v2_recommendation_chipless_ranking_response_dto._internal_.DiRecommendV1RankingItemsResponseChipExpMetaDto.html}
 * */
var DiRecommendV1RankingItemsResponseChipExpMetaDto = zod_1.z.object({
    /** 페이지 채널 (영역) - PLACE_PDP_BOTTOM */
    expChannel: zod_1.z.string(),
    /** 페이지 채널 이름 */
    expChannelTitle: zod_1.z.string().optional(),
    /** 숙박 타입  enum */
    expContentsType: zod_1.z.string().nullable(),
    expCustomLogs: zod_1.z.object({}).optional(),
    expDynamicConfig: zod_1.z.object({}).nullable(),
    /** 조회 입력 값의 상품 유형 enum */
    expElementInputType: zod_1.z.string(),
    /** 조회 결과의 상품 유형 enum */
    expElementOutputType: zod_1.z.string(),
    /** 조회 값의 유형 enum */
    expElementType: zod_1.z.string(),
    /** 실험 내 그룹 */
    expGroup: zod_1.z.string().nullable(),
    /** 실험 내 그룹 번호 */
    expGroupNo: zod_1.z.number().nullable(),
    /** 실험 api의 요청자 성격 */
    expKindOfApi: zod_1.z.string().nullable(),
    /** 실험 내 라벨 */
    expLabel: zod_1.z.string(),
    /** 실험 내 라벨 타입 */
    expLabelType: zod_1.z.string().nullable(),
    /** 실험 ID */
    expLabId: zod_1.z.string().nullable(),
    /** 추천 알고리즘 명 - HEURISTIC_WEIGHT */
    expMethodName: zod_1.z.string().optional(),
    /** 추천 알고리즘 버전 */
    expMethodVersion: zod_1.z.string().optional(),
    expReferrer: zod_1.z.string().nullable(),
    /** 데이터 소스 이름 (Dynamo, MySQL, API 등) */
    expSource: zod_1.z.string(),
    /** 위젯의 아이템을 생성한 파티션 키 값(요청된) - M1:28082 */
    expSpecifier: zod_1.z.string(),
    /** 위젯의 아이템을 생성한 파티션 키 값 (실제 사용된) - C1 */
    expSpecifierActual: zod_1.z.string(),
    /** 요청 시점의 timestamp (UTC) */
    expTimestamp: zod_1.z.number().nullable(),
    /** 채널 위젯 - CROSS_SELL */
    expWidget: zod_1.z.string(),
    /** 위젯의 포지션 (순서) */
    expWidgetPosition: zod_1.z.number().nullable(),
    /** 위젯 서브타이틀 */
    expWidgetSubTitle: zod_1.z.string().nullable(),
    /** 위젯 타이틀 */
    expWidgetTitle: zod_1.z.string().nullable(),
    /** 실험 카탈로그
     * TODO: 문서에는 존재하지 않는 필드
     * */
    expCatalog: zod_1.z.string().nullable(),
    /** 실험 카탈로그 코드
     * TODO: 문서에는 존재하지 않는 필드
     */
    expLabelCode: zod_1.z.string().nullable(),
});
/**
 * 위젯에서 하나의 탭
 * @see {@link https://yanolja-dev-cx-api-bucket.s3.ap-northeast-2.amazonaws.com/api-document/cx-display-api/classes/controller_widget_top_rated_product_ranking_dto_widget_v1_top_rated_product_ranking_response_dto._internal_.WidgetTopRatedProductRankingResponseTabDto.html}
 * */
var WidgetTopRatedProductRankingResponseTabDto = zod_1.z.object({
    /** 위젯 헤더 */
    header: WidgetTopRatedProductRankingResponseTabHeaderDto.optional(),
    /** 위젯 아이템 */
    items: zod_1.z.array(WidgetTopRatedProductRankingResponseTabItemDto),
    /** DI에서 제공하는 로깅 용 메타데이터 전달받은대로 제공하고(bypass) 변경 가능성이 있으므로 내부까지 validation 하지 않는다 */
    expMeta: DiRecommendV1RankingItemsResponseChipExpMetaDto,
    /**
     * 로그에 들어가는 정보
     * WidgetTopRatedProductRankingResponseTabLogMetaDto
     * @see {@link https://yanolja-dev-cx-api-bucket.s3.ap-northeast-2.amazonaws.com/api-document/cx-display-api/classes/controller_widget_top_rated_product_ranking_dto_widget_v1_top_rated_product_ranking_response_dto._internal_.WidgetTopRatedProductRankingResponseTabLogMetaDto.html}
     * */
    logMeta: common_1.CommonItemLogMetaDto,
});
/**
 * 위젯 객체
 * 위젯의 계층은
 * 위젯 - 탭[] - 탭아이템[] 으로 구성되어 있다.
 * @see {@link https://yanolja-dev-cx-api-bucket.s3.ap-northeast-2.amazonaws.com/api-document/cx-display-api/classes/controller_widget_top_rated_product_ranking_dto_widget_v1_top_rated_product_ranking_response_dto.WidgetV1TopRatedProductRankingResponseDto.html}
 * */
var WidgetV1TopRatedProductRankingResponseDto = zod_1.z.object({
    header: zod_1.z
        .object({
        title: zod_1.z.string(),
        subTitle: zod_1.z.string(),
        more: common_1.WidgetMoreSchema.optional(),
    })
        .nullish(),
    items: zod_1.z.array(WidgetTopRatedProductRankingResponseTabDto),
    logMeta: zod_1.z.record(zod_1.z.unknown()),
});
// 프론트 BFF 이름 컨벤션을 따르기 위한 변수재선언
exports.TopRatedProductRankingWidgetDataSchema = WidgetV1TopRatedProductRankingResponseDto;
